import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { RATINGS } from '../../../../lib/schema.js';
import RatingLabel from '../../../RatingLabel.jsx';

StakeholderInfluencesFilter.defaultProps = {
  selectedStakeholderInfluences: [],
};

function StakeholderInfluencesFilter({
  selectedStakeholderInfluences,
  navigateAction,
}) {
  const selectedCount = selectedStakeholderInfluences.length;
  const handleSelect = useCallback(
    (stakeholderInfluence) =>
      navigateAction({
        stakeholderInfluences: stakeholderInfluence
          ? xor(selectedStakeholderInfluences, [stakeholderInfluence])
          : [],
      }),
    [selectedStakeholderInfluences]
  );

  const renderMenuItem = useCallback(
    (stakeholderInfluence) => (
      <React.Fragment key={stakeholderInfluence}>
        <MenuItem
          active={selectedStakeholderInfluences.includes(stakeholderInfluence)}
          eventKey={stakeholderInfluence}
          onSelect={handleSelect}
        >
          <RatingLabel rating={stakeholderInfluence} />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStakeholderInfluences]
  );
  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Stakeholder Influence</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="stakeholder-influence-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {RATINGS.HIGH_MEDIUM_LOW.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default StakeholderInfluencesFilter;
